import React, { type ReactNode } from 'react';
import FeedbackIcon from '@atlaskit/icon/core/feedback';
import FeedbackIconLegacy from '@atlaskit/icon/glyph/feedback';
import Link from '@atlaskit/link';
import { Text } from '@atlaskit/primitives';
import SectionMessage from '@atlaskit/section-message';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import { SLACK_HELP_URL } from '../../../common/constants';
import messages from './messages';

export const InfoBanner = () => {
	const { formatMessage } = useIntl();

	return (
		<SectionMessage
			appearance="discovery"
			icon={() => (
				<FeedbackIcon
					LEGACY_fallbackIcon={FeedbackIconLegacy}
					spacing="spacious"
					label="feedback"
					color={token('color.icon')}
				/>
			)}
		>
			{formatMessage(messages.descriptionNonFinal, {
				strong: (chunks: ReactNode) => <Text as="strong">{chunks}</Text>,
				slack: (chunks: ReactNode) => (
					<Link target="_blank" href={SLACK_HELP_URL}>
						{chunks}
					</Link>
				),
			})}
		</SectionMessage>
	);
};
